import { useState } from 'react';
import { faqItems } from '@/mocks/faq';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <section className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900">
            常见问题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">
            关于女性网站色彩设计，你关心的都在这里
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="bg-background-100 rounded-lg border border-background-200/70 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
                onClick={() => toggleFAQ(index)}
                aria-expanded={openIndex === index}
              >
                <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {item.question}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-lg text-foreground-500 transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 pb-4 md:pb-5 px-4 md:px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
    </section>
  );
}